<div class="table-card questions-chart-card">
  <div class="card-header">
    <div class="titles">
      <h4 class="card-title">عدد الأسئلة الشهري</h4>
      <p class="subtitle">المُجاب عنها مقابل غير المُجاب</p>
    </div>

    <div class="legend">
      <span class="legend-item">
        <span class="dot answered"></span>
        مجاب علية
      </span>
      <span class="legend-item">
        <span class="dot unanswered"></span>
        غير مجاب
      </span>
    </div>
  </div>

  <div [id]="chartId" class="chart-container"></div>
</div>
